

<!-- 
based on @Takachi67@blwasham  https://github.com/Takachi67/vue3-autocomplete MIT licensed by (c) Takachi67
modified by machinaexphilip Philip Steimel for the machina commons dingsda2meX project 2021
-->
   
<template>
  <div class="vue3-autocomplete-container">
    <div :style="clearButton ?'height: 0;':false">
      <input
        ref="autocompleteRef"
        type="text"
        @input="handleInput"
        v-bind="$attrs"
        v-model="searchText"
        :placeholder="placeholder"
        :class="getInputClass"
        :style="clearButton ? 'padding-right:2.1em' : ''"
        @focus="displayResults"
        @blur="hideResults"
      />
      <button v-if="clearButton" class="is-rounded autocomplete-clear-button" 
        @click="onClearPressed"><Icon :icon="['fa','times']" ></Icon></button>
    </div>

    <div :style="{ width: inputWidth + 'px' }" :class="getResultsContainerClass" v-if="shouldShowResults">
     
    <div
          v-if="useHtmlForResults"
          v-for="item in filteredResults"
          :key="item.id"
          :class="getResultsItemClass"
          @click="clickItem(item)"
          @mousedown.prevent
          v-html="displayItem(item)"
      ></div>
         
    
    <div
          v-if="!useHtmlForResults"
          v-for="item in filteredResults"
          :key="item"
          :class="getResultsItemClass"
          @click="clickItem(item)"
          @mousedown.prevent
      >{{ displayItem(item) }}</div>
    </div>
     
    
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import Icon from '@/components/Template/Icon.vue'

export default {
  name: 'Autocomplete',
  inheritAttrs: false,
  components:[
    Icon
  ],
  props: {
    debounce: {
      default: 0
    },
    inputClass: {
      default: []
    },
    useHtmlForResults: {
      default: false
    },
    max: {
      default: 10
    },
    placeholder: {
      default: ''
    },
    results: {
      default: []
    },
    resultsContainerClass: {
      default: []
    },
    resultsItemClass: {
      default: []
    },
    displayItem: {
      type: Function,
      default: (item) => {  
        return typeof item === 'string' ? item : item.name
      }
    },
    clearButton: {
      default: false
    }
  },
  emits: [
    'input',
    'onSelect',
    'onClear'
  ],
  setup(props, context) {
    const autocompleteRef = ref()
    let inputWidth = ref(0),
        searchText = ref(''),
        timeout,
        showResults = ref(true)
    /**
     * Same as Vue2 'mounted' function, used to get refs correctly
     */
    onMounted(() => {
      inputWidth.value = autocompleteRef.value.offsetWidth - 2
    })
    /**
     * Triggered on input changes with a dynamic debounce
     * @param { InputEvent } e
     */
    function handleInput(e) {
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        context.emit('input', e.target.value);
        displayResults();
      }, props.debounce)
    }
    /**
     * Triggered on click on a result item
     */
    function clickItem(data) {
      context.emit('onSelect', data)
      showResults.value = false
    }
    /**
     * Called on focus
     */
    function displayResults() {
      showResults.value = true
    }
    /**
     * Called on blur
     */
    function hideResults() {
      showResults.value = false
    }
    /**
     * called on clear button pressed. Sets text to empty string and dispatched event
     */
    function onClearPressed(){
      setText('');
      context.emit('onClear');
    }
    /**
     * Manually update the displayed text in the input
     * @param value
     */
    function setText(value) {
      searchText.value = value
    }
    /**
     * Return class(es) for input element
     */
    const getInputClass = computed(() => {
      return props.inputClass.length > 0 ? props.inputClass : ['vue3-input']
    })
    /**
     * Return class(es) for results container element
     */
    const getResultsContainerClass = computed(() => {
      return props.resultsContainerClass.length > 0 ?
          props.resultsContainerClass :
          ['vue3-results-container']
    })
    /**
     * Return class(es) for results item elements
     */
    const getResultsItemClass = computed(() => {
      return props.resultsItemClass.length > 0 ?
          props.resultsItemClass :
          ['vue3-results-item']
    })
    /**
     * Show results depending on results length and showResults boolean
     */
    const shouldShowResults = computed(() => {
      return showResults.value && (props.results.length > 0)
    })
    /**
     * Return results filtered with the 'max' props
     */
    const filteredResults = computed(() => {
      return props.results.slice(0, props.max)
    })
    /**
     * Return data, making them reactive
     */
    return {
      searchText,
      showResults,
      autocompleteRef,
      inputWidth,
      displayResults,
      hideResults,
      handleInput,
      clickItem,
      onClearPressed,
      setText,
      filteredResults,
      getInputClass,
      getResultsContainerClass,
      getResultsItemClass,
      shouldShowResults
    }
  }
}
</script>

<style lang="scss" scoped>
.vue3-autocomplete-container {
  display: flex;
  width: 100%;
  flex-direction: column;
  .vue3-input {
    border-radius: 5px;
    &:focus {
      outline: none;
    }
  }
  .vue3-results-container {
    position: absolute;
    top: 27px;
    border: 1px solid black;
    z-index: 99;
    background: white;
  }
  .vue3-results-item {
    list-style-type: none;
    padding: 5px;
    border-bottom: 1px solid black;
    &:hover {
      cursor: pointer;
    }
    &:nth-last-child(1) {
      border-bottom: none;
    }
  }
  .autocomplete-clear-button{
    border-radius: 50%;
    height: 1.7em;
    width: 1.7em;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: 0;
    border-width: 1px;
    position: relative;
    top: -2.3em;
    float: right;
    margin-right: 0.7em;
    z-index: 2;
    background-color: rgba(235,235,235,0.5);
    opacity: 0.7;
}
}
</style>
